import React from "react";
import ButtonTable from "../table/buttonTable";

export function InfoIcon(props) {
    if (!props.visible) return null;
    return (
        <ButtonTable
            solid={true}
            style={{
                margin: 0,
                borderRadius: "48%",
                width: 35,
                height: 34,
                cursor: "help",
            }}
            title={props.title}
            type={props.type || "primary"}
            icon={"fas fa-info"}
            visible={true}
            event={() => ({})}
        />
    );
}
